import { useEffect, FC } from 'react';
import { removeNode } from './utils';
import { extractCountryAndCulture, readAuthToken, resolveChatCountry } from './chat-locale-utils';

const initialize = async (locale: string, countryIso3: string) => {
  // eslint-disable-next-line import/no-unresolved
  const { initializeChat } = await import('yl-zcc-chat/ChatLoader');
  initializeChat({ locale, country: countryIso3 });
};

export interface Props {
  locale: string;
  countryIso3: string;
}

export const ZccChat: FC<Props> = ({ locale, countryIso3 }) => {
  useEffect(() => {
    const token = readAuthToken();
    const { country } = extractCountryAndCulture(token);
    const resolvedCountry = resolveChatCountry(countryIso3, country);

    if (resolvedCountry) {
      initialize(locale, resolvedCountry);
    }
    return () => {
      removeNode('.zcc-frame');
    };
  }, [locale, countryIso3]);
  return null;
};
